import { cn } from "@/lib/utils";
import { AvatarSize, AVATAR_SIZE_CLASSES } from "@/common/avatar.common";
import { SKELETON_BASE_CLASS } from "@/common/skeleton.common";

interface UserAvatarSkeletonProps {
  size?: AvatarSize;
  className?: string;
}

export function UserAvatarSkeleton({ 
  size = "md", 
  className 
}: UserAvatarSkeletonProps) {
  return (
    <div 
      className={cn(
        SKELETON_BASE_CLASS,
        "rounded-sm",
        AVATAR_SIZE_CLASSES[size],
        className
      )}
      aria-hidden="true"
    />
  );
} 